import routes from './routes'

export const SUPPORT_CATEGORY = {
  SUPPORT: 'support',
  FEEDBACK: 'feedback',
  COMMERCIAL: 'commercial',
}

export const SUPPORT_CATEGORY_OPTIONS = [
  { value: SUPPORT_CATEGORY.SUPPORT, label: 'Soporte' },
  { value: SUPPORT_CATEGORY.FEEDBACK, label: 'Comentarios / feedback' },
  {
    value: SUPPORT_CATEGORY.COMMERCIAL,
    label: 'Comercial (negocios, integraciones, alianzas)',
  },
]

export const SUPPORT_CATEGORY_LABELS = {
  [SUPPORT_CATEGORY.SUPPORT]: 'Soporte',
  [SUPPORT_CATEGORY.FEEDBACK]: 'Feedback',
  [SUPPORT_CATEGORY.COMMERCIAL]: 'Comercial',
}

export const SUPPORT_STATUS = {
  OPEN: 'open',
  CLOSED: 'closed',
}

/** Query topics that prefill the help form (demand signals / gated features). */
export const SUPPORT_TOPIC = {
  LEGACY_FIXED_AMOUNT: 'legacy-fixed-amount',
}

export const SUPPORT_TOPIC_PREFILL = {
  [SUPPORT_TOPIC.LEGACY_FIXED_AMOUNT]: {
    category: SUPPORT_CATEGORY.FEEDBACK,
    message:
      'Tengo una pensión antigua fijada en pesos (no en UTM). Me gustaría configurarla en Cotidía. Mi caso: ',
  },
}

export const buildSupportHelpPath = (topic) => {
  if (!topic) return routes.help
  return `${routes.help}?topic=${encodeURIComponent(topic)}`
}
